import React, { useEffect, useState } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'
import moment from 'moment'
import "@/assets/scss/pages/relationships.scss"
import { Tooltip } from '@mui/material'
import Skeleton from 'react-loading-skeleton'

function ReservationsStatus({ title, apiEndpoint }) {
    const INITIAL_FILTERS = {
        partner_id: "",
        category_id: "",
    }

    const [data, setData] = useState({
        loading: true,
        total: 0,
        stats: [],
        legend: [],
        filtersContent: {
            categories: [],
            partners: [],
        },
    })
    const [filters, setFilters] = useState(INITIAL_FILTERS)

    useEffect(() => {
        loadData()
    }, [apiEndpoint, filters])

    const loadData = () => {
        setData(prev => ({ ...prev, loading: true }))

        Api.get(`${apiEndpoint}?partner_id=${filters.partner_id}&category_id=${filters.category_id}`)
            .then(res => {
                const apiData = res.data.data

                // Transform API data to component format
                const total = apiData.total || 0
                const stats = [
                    { id: 1, name: trans('statuses.accepted'), count: apiData.accepted || 0, color: "#67C9A4", color2: "#89B9B9" },
                    { id: 2, name: trans('random.pendding'), count: apiData.pending || 0, color: "#181f67", color2: "#477090" },
                    { id: 3, name: trans('statuses.declined'), count: apiData.declined || 0, color: "#ff8fab", color2: "#F5B2A3" }
                ]

                setData(prev => ({
                    ...prev,
                    loading: false,
                    total: total,
                    stats: stats,
                    legend: stats,
                    filtersContent: res.data?.filters,
                }))
            })
            .catch(err => {
                console.error('Error loading reservation data:', err)
                setData(prev => ({
                    ...prev,
                    loading: false,
                    total: 0,
                    stats: [],
                    legend: []
                }))
            })
    }

    const calculateStackedBar = () => {
        if (!data || !data.stats || data.total === 0) return []

        let cumulativePercentage = 0

        return data.stats.map((item) => {
            const percentage = data.total > 0 ? (item.count / data.total) * 100 : 0
            const startPosition = cumulativePercentage
            const endPosition = cumulativePercentage + percentage
            const centerPosition = startPosition + (percentage / 2)

            cumulativePercentage += percentage

            return {
                ...item,
                percentage: Math.round(percentage * 10) / 10,
                startPosition,
                endPosition,
                centerPosition
            }
        })
    }

    const stackedData = calculateStackedBar()

    const handleClearFilters = () => {
        setFilters(INITIAL_FILTERS)
    }

    function handleFilterChange(e) {
        const { name, value } = e.target

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    return (
        <div className="pannel">
            <h3>{title} ({data.total})</h3>
            <div
                className="filter-standard"
                style={{
                    width: "fit-content",
                }}
            >
                <div className="col">
                    <select
                        onChange={handleFilterChange}
                        name="partner_id"
                        style={{
                            width: "fit-content",
                        }}
                        value={filters.partner_id}
                    >
                        <option value="">{trans('random.allPartners')}</option>
                        {data.filtersContent.partners.map((partner) => (
                            <option key={partner.id} value={partner.id}>
                                {partner.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col">
                    <select
                        onChange={handleFilterChange}
                        name="category_id"
                        style={{
                            width: "fit-content",
                        }}
                        value={filters.category_id}
                    >
                        <option value="">{trans('random.allCategories')}</option>
                        {data.filtersContent.categories.map((category) => (
                            <option key={category.id} value={category.id}>
                                {category.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col">
                    <button
                        type="button"
                        className="button-clear-filter"
                        onClick={handleClearFilters}
                    ></button>
                </div>
            </div>
            <hr />

            {data.loading ? (
                <Skeleton height={45} count={5} />
            ) : data.total === 0 ? (
                <div
                    className="alert warning"
                    style={{
                        width: "100%",
                        marginBottom: "auto",
                    }}
                >
                    {trans("messages.noDataFound")}
                </div>
            ) : (

                <>
                    <div className="stacked-bar-wrapper">
                        <div className="stacked-bar-container">
                            {stackedData.map((item, index) => (
                                <Tooltip
                                    classes={{ tooltip: 'dashboard-stats-tooltip' }}
                                    arrow key={item.id || index}
                                    title={<>
                                        <p>
                                            {item.name}
                                        </p>
                                        <b>
                                            {item.count}
                                        </b>
                                    </>}
                                    followCursor
                                >
                                    <div
                                        className="stacked-bar-segment"
                                        style={{
                                            width: `${item.percentage}%`,
                                            backgroundImage: `linear-gradient(to right, ${item.color}, ${item.color2})`,
                                        }}
                                    // onMouseEnter={(event) => handleSegmentHover(item, event)}
                                    // onMouseLeave={() => setHoveredSegment(null)}

                                    />
                                </Tooltip>
                            ))}
                        </div>
                    </div>

                    <ul className="legend-horizontal">
                        {data.legend && data.legend.map((item, index) => (
                            <li key={item.name + index}>
                                <span
                                    style={{ backgroundImage: `linear-gradient(to right, ${item.color}, ${item.color2})` }}
                                ></span>
                                {item.name}
                            </li>
                        ))}
                    </ul>
                </>
            )
            }
        </div>
    )
}

export default ReservationsStatus